<!-- =========================================================================================
    File Name: KnowledgeBaseCategory.vue
    Description: Knowledge Base Category Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="knowledge-base-category-page">
        <div class="w-full flex justify-between">
            <p class="mb-4">{{ kb.title }}</p>
            <span>
                <vs-button icon="add" color="primary" type="border" @click="addKnowledgeBase = true">Add</vs-button>
            </span>
        </div>
        <div class="vx-row mt-8 match-height">
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base" v-for="section in kb.children" :key="section.id">
                <vx-card>
                    <div class="w-full flex justify-between">
                        <h4 class="mb-4">{{ section.title }}</h4>
                        <div class="flex">
                            <vs-button color="warning" size="small" type="border" icon="edit" @click="updateKb(section)"></vs-button>
                            <vs-button color="danger" size="small" type="border" icon="delete" class="ml-1" @click="removeKnowledgeBase(section.id)"></vs-button>
                        </div>
                    </div>
                    <ul class="bordered-items">
                        <li v-for="que in section.items" :key="que.id" class="py-2"><router-link
                            :to="{name:'pageKnowledgeBaseCategoryItem',params:{itemId:que.id}}">{{ que.title }}</router-link>
                        </li>
                    </ul>
                    <div class="w-full flex justify-end mt-2">
                        <vs-button color="success" size="small" type="border" icon="add" @click="openItemKb(section.id)"></vs-button>
                    </div>
                </vx-card>
            </div>
        </div>
        <AddKnowledgeBase
            :kbActive="addKnowledgeBase"
            @closeKBActive="closeKBActive"
            @getPushNewKb="getPushNewKb"
            :parent="kb.id"
        />
        <AddKnowledgeBaseItem
            :kbItemActive="kbItemActive"
            @closeKbItemActive="closeKbItemActive"
            :parent="parent"
            @pushKbItem="pushKbItem"
         />
         <EditKnowledgeBase
            :editActive="editKnowledgeBase"
            :editData="editData"
            @closeEditKb="closeEditKb"
            @getUpdateKb="getUpdateKb"
          />
    </div>
</template>

<script>
import {getKbById,deleteKnowledgeBase} from '../../../api/knowledgebase';
import AddKnowledgeBase from './components/AddKnowledgeBase';
import AddKnowledgeBaseItem from './components/AddKnowledgeBaseItem';
import EditKnowledgeBase from './components/EditKnowledgeBase'
export default{
    data() {
        return {
            kb:new Object(),
            addKnowledgeBase:false,
            kbItemActive:false,
            parent:0,
            categoryTitle: 'Category Name',
            editKnowledgeBase:false,
            editData:null,
            delId:null,
            }
    },
    computed: {
    },
    methods: {
        closeKBActive() {
            this.addKnowledgeBase = false
        },
        getPushNewKb(data) {
            this.addKnowledgeBase = false;
            this.kb.children.push(data)
        },
        closeKbItemActive() {
            this.kbItemActive = false;
        },
        openItemKb(id) {
            this.parent = id;
            this.kbItemActive = true
        },
        pushKbItem(data) {
            var item = this.kb.children.findIndex(item => item.id === data.knowledge_base);
            if(item !== -1) {
                this.kb.children[item].items.push(data);
            }
            this.kbItemActive = false
        },
        closeEditKb() {
            this.editKnowledgeBase = false;
        },
        updateKb(data) {
            this.editData = data;
            this.editKnowledgeBase = true
        },
        getUpdateKb(data) {
            var item = this.kb.children.findIndex(item => item.id === data.id);
            if(item !== -1) {
                this.kb.children.splice(item,1);
                this.kb.children.splice(item,0,data)
            }
            this.editKnowledgeBase = false;
        },
        removeKnowledgeBase(id) {
            this.delId = id
            this.$vs.dialog({
                type:'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                accept:this.acceptDelete
            })
        },
        acceptDelete() {
            deleteKnowledgeBase({kb_id:this.delId}).then(res => {
                if(res.data.message === 'delete') {
                    var item = this.kb.children.findIndex(item => item.id === this.delId);
                    this.kb.children.splice(item,1)
                }
            })
        },
    },
    components: {
        AddKnowledgeBase,
        AddKnowledgeBaseItem,
        EditKnowledgeBase
    },
    created() {
        getKbById({id:this.$route.params.kbId}).then(res => {
            this.kb = res.data.data
        })
    },
    mounted() {
        this.$emit('changeRouteTitle', 'Category');
    }
}
</script>
